import { createFileRoute, redirect } from '@tanstack/react-router';

const AllowedServiceIssues = ['treatment-concerns', 'unresolved-contact-attempts', 'manager-escalations'];

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/analytics/call-intelligence/service-issue_/$type')({
  staticData: { team: 'analytics' },
  params: {
    parse: (raw) => ({ type: raw.type }),
  },
  beforeLoad: ({ params }) => {
    if (!AllowedServiceIssues.includes(params.type)) {
      throw redirect({ to: '/analytics/call-intelligence/main', replace: true });
    }
  },
});
